import { render, staticRenderFns } from "./nr-project-case-edit.vue?vue&type=template&id=0fd674c0&scoped=true"
import script from "./nr-project-case-edit.vue?vue&type=script&lang=ts"
export * from "./nr-project-case-edit.vue?vue&type=script&lang=ts"
import style0 from "./nr-project-case-edit.vue?vue&type=style&index=0&id=0fd674c0&prod&lang=scss&scoped=true"
import style1 from "./nr-project-case-edit.vue?vue&type=style&index=1&id=0fd674c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd674c0",
  null
  
)

export default component.exports